import styled, { css } from 'styled-components';
import { HotKeys } from 'react-hotkeys';
import { getThemeProp } from 'theme';

export const searchInputOrPlaceholderBase = css`
  background-color: ${getThemeProp('colors.rhinoBlue')};
  border: 0;
  border-radius: 6px;
  box-sizing: border-box;
  font-size: 12px;
  height: 28px;
  line-height: 28px;
  margin: 0;
  max-width: 110%;
  padding: 0 12px;
  width: 250px;
`;

export const SSearchInput = styled.input`
  && {
    ${searchInputOrPlaceholderBase};
    box-shadow: none;
    color: ${getThemeProp('colors.white')};
    padding-left: 40px;
    text-align: left;

    &:focus {
      background: ${getThemeProp('colors.rhinoBlue')};
      border: 0;
      box-shadow: 0 0 0 2px ${getThemeProp('colors.havelockBlue')};
    }
  }
`;

export const SPlaceholder = styled.div<Record<'isActive', boolean>>`
  ${searchInputOrPlaceholderBase};
  color: ${getThemeProp('colors.solitudeGrey')};
  text-align: center;
  display: ${props => (props.isActive ? 'none' : 'inline-block')};

  & > i {
    display: inline-block;
    font-size: 14px;
    line-height: 28px;
    margin-right: 8px;
    transform: translateY(2px);
  }
`;

export const SSearchInputContainer = styled.div<{ isActive: boolean }>`
  display: ${props => (props.isActive ? 'inline-block' : 'none')};
  position: relative;
`;

export const SSearchIcon = styled.i.attrs(() => ({
  className: 'icon-search',
}))`
  color: ${getThemeProp('colors.white')};
  font-size: 14px;
  height: 28px - 8px;
  left: 12px;
  line-height: 28px - 4px;
  padding-right: 5px;
  position: absolute;
  top: 4px;
`;

export const SContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
  width: 250px;
`;

export const SHotKeys = styled(HotKeys)`
  display: inline-block;
`;
